import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Map } from 'immutable';
import { firstValueFrom, Observable, ReplaySubject } from 'rxjs';

import { DcIcons } from '../../app-dc.icons';

type ConsumerElement = {
	label: string;
	elemUrl: string;
	type: string;
};

export type ConsumptionReport = {
	consumedWithin: Array<ConsumerElement>;
	consumedElementLabel: string;
};

export type DeleteReport = {
	code: number;
	msg: string;
	nonDeletedElementsCount: number;
	elementsDeletedCount: number;
	elementsDeleteRequestCount: number;
	details: Array<ConsumptionReport>;
};

type ViewConsumptionReport = ConsumptionReport & { isOpen: boolean };

@Component({
	selector: 'app-delete-report',
	templateUrl: './app-delete-report.component.html',
	styleUrls: ['./app-delete-report.component.scss'],
})
export class AppDeleteReportComponent<
	T extends DeleteReport
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		message: string;
		totalNotDeleted: number;
		totalDeleted: number;
		totalRequestToDelete: number;
		report: Map<string, ViewConsumptionReport>;
	}>;

	private readonly mappingSubject = new ReplaySubject<
		Map<string, ViewConsumptionReport>
	>(1);
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'delete-popup-report';

		const initialValue = Map<string, ViewConsumptionReport>(
			this.modalData.details.map((it) => [
				it.consumedElementLabel,
				{
					...it,
					isOpen: false,
				},
			])
		);

		this.mappingSubject.next(initialValue);

		this.vo$ = combineAll({
			message: this.modalData.msg,
			totalNotDeleted: this.modalData.nonDeletedElementsCount,
			totalDeleted: this.modalData.elementsDeletedCount,
			totalRequestToDelete: this.modalData.elementsDeleteRequestCount,
			report: this.mappingSubject,
		});
	}

	public async toggleReportFor(consumedLabel: string): Promise<void> {
		const current = await firstValueFrom(this.mappingSubject);
		const val = current.get(consumedLabel);
		if (!val) {
			return;
		}
		val.isOpen = !val.isOpen;
		const updated = current.set(consumedLabel, val);
		this.mappingSubject.next(updated);
	}
}
